import { rankingData, faqData, contactData, aboutData, commentsData, indexData } from '@/mocks/home';

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">热门漫画排行榜</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">实时热度榜单，发现当下最受欢迎的韩漫、日漫、国漫作品</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div key={item.id}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-bold text-sm font-heading flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate font-body">{item.title}</h3>
                  {item.isHot && (
                    <span className="flex-shrink-0 inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-600 text-[10px] font-medium">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mb-1">{item.author} · {item.genre}</p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className={`text-xs ${item.change === 'up' ? 'ri-arrow-up-line text-primary-500' : item.change === 'down' ? 'ri-arrow-down-line text-foreground-400' : 'ri-subtract-line'}`}></i>
                  <span>{item.hot} 人气</span>
                </div>
              </div>

              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400 text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500">关于虫虫动漫的常见疑问，这里都有答案</p>
        </div>

        <div className="space-y-3">
          {faqData.map((item) => (
            <div key={item.id} className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 font-body flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-5">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">{contactData.title}</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">{contactData.description}</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6 md:p-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-xl text-primary-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.email}</p>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-xl text-accent-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">微信</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.wechat}</p>
              </div>
            </div>
            <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-question-answer-line text-xl text-secondary-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">QQ 交流群</p>
                <p className="text-sm font-medium text-foreground-800">{contactData.qq}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">关于我们</h2>
        </div>

        <div className="space-y-4">
          {aboutData.paragraphs.map((p, i) => (
            <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-2xl mx-auto">
              {p}
            </p>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-10 pt-8 border-t border-background-200/70">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">2000+</div>
            <div className="text-xs text-foreground-500 mt-1">精选漫画资源</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">3大</div>
            <div className="text-xs text-foreground-500 mt-1">核心分类</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">500万+</div>
            <div className="text-xs text-foreground-500 mt-1">漫画爱好者</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">每日</div>
            <div className="text-xs text-foreground-500 mt-1">同步更新</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">读者评价</h2>
          <p className="text-sm md:text-base text-foreground-500">听听漫画爱好者们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((item) => (
            <div key={item.id} className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6 flex flex-col">
              <div className="flex items-center gap-2 mb-1">
                {[1,2,3,4,5].map((star) => (
                  <i key={star} className={`text-xs ${star <= item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-300'}`}></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">{item.content}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-primary-600">{item.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.genre} · {item.date}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">专题索引</h2>
          <p className="text-sm md:text-base text-foreground-500">按主题快速发现漫画，总有一个专题适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <div key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/70 p-4 md:p-5 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className={`w-10 h-10 rounded-lg ${item.color} flex items-center justify-center mb-3`}>
                <i className="ri-folder-line text-background-50 text-lg"></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 font-body group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{item.desc}</p>
              <span className="text-xs text-foreground-400">{item.count} 部作品</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}